















































import Vue from 'vue'
import {
  Configuration,
  UploadedFile,
  OfficerDetail,
  OfficerMeetingDetail,
  ConferenceDoctorOfficerRestControllerApi,
  EntryOfficerMeetingDetail,
} from '@/types/api-docs'
import FileForm from '@/components/FileForm.vue'
import OfficerMeetingDetailForm from '@/components/OfficerMeetingDetailForm.vue'
import attendStatus from '@/mixins/attendStatusEnum'

export interface DataType {
  pageName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breadcrumbs: Array<any>
  meeting?: OfficerMeetingDetail
  entryMeetingAttend?: EntryOfficerMeetingDetail
  officers: OfficerDetail[]
  officerMeetingsId: number
  uploadedFiles?: { [p: string]: UploadedFile }
  isFormValid: boolean
  isConference: boolean
}

const meetingApi = new ConferenceDoctorOfficerRestControllerApi(
  new Configuration({ basePath: `${window.location.origin}` })
)

export default Vue.extend({
  mixins: [attendStatus],
  components: {
    OfficerMeetingDetailForm,
    FileForm,
  },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: '理事･役員会一覧',
          href: '/member/officers',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      meeting: undefined,
      entryMeetingAttend: undefined,
      officers: [],
      officerMeetingsId: Number(this.$route.params.id),
      uploadedFiles: undefined,
      isFormValid: true,
      isConference: false,
    }
  },
  async mounted() {
    await this.fetchMeetingDetail()
    await this.fetchMeetingFiles()
    await this.fetchEntryOfficerMeetingDetail()
  },
  computed: {},
  methods: {
    async fetchMeetingDetail() {
      const { data } = await meetingApi.fetchMemberOfficerMeetingDetail(this.officerMeetingsId)
      this.meeting = data
    },
    async fetchEntryOfficerMeetingDetail() {
      const { data } = await meetingApi.fetchMemberEntryOfficerMeetingDetail(this.officerMeetingsId)
      this.entryMeetingAttend = data
    },
    async fetchMeetingFiles() {
      const { data } = await meetingApi.fetchMemberOfficerMeetingFiles(this.officerMeetingsId)
      this.uploadedFiles = data
    },
    existFile() {
      if (!this.uploadedFiles) {
        return false
      }
      for (let key of Object.keys(this.uploadedFiles)) {
        if (this.uploadedFiles[key].url) {
          return true
        }
      }
      return false
    },
  },
})
